import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";

// MUI Stuff
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Tooltip, Typography } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import CircularProgress from "@material-ui/core/CircularProgress";

// Icons
import EditIcon from "@material-ui/icons/Edit";

// Redux stuff
import { connect } from "react-redux";
import { postScream, postImage } from "../../redux/actions/dataActions";
// import MyButton from "../../util/MyButton";

const styles = {
  submitButton: {
    position: "relative",
  },
  progressSpinner: {
    position: "absolute",
  },
  closeButton: {
    position: "absolute",
    left: "90%",
    top: "10%",
  },
};

class UploadScream extends Component {
  state = {
    open: false,
    body: "",
    errors: {},
  };

  handleImage = (event) => {
    const image = event.target.files[0];
    const fromData = new FormData();
    fromData.append("image", image, image.name);
    this.props.postImage(fromData);
  };
  handleEdPicture = () => {
    const fileInput = document.getElementById("postImageInput");
    fileInput.click();
  };

  componentWillReceiveProps(nextProp) {
    if (nextProp.UI.errors) {
      this.setState({
        errors: nextProp.UI.errors,
      });
    }
    if (!nextProp.UI.errors && !nextProp.UI.loading) {
      this.setState({ body: "" });
    }
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };
  handleSubmit = (event) => {
    event.preventDefault();
    this.props.postScream({ body: this.state.body });
  };
  render() {
    const { errors } = this.state;
    const {
      classes,
      UI: { loading },
      Image: { load },
    } = this.props;
    return (
      <Fragment>
        <DialogTitle>
          Post a new scream <br />
          <Typography color="textSecondary">
            Note: You cannot post a scream without image
          </Typography>
        </DialogTitle>

        <br />

        <input
          type="file"
          id="postImageInput"
          hidden="hidden"
          onChange={this.handleImage}
        />
        <form onSubmit={this.handleSubmit}>
          <Tooltip title="Upload Image for scream!" placement="top">
            <IconButton
              onClick={this.handleEdPicture}
              disabled={load}
              className="button"
            >
              <EditIcon color="primary" />
              <Fragment>
                Upload photo
                {load && (
                  <CircularProgress
                    size={30}
                    className={classes.progressSpinner}
                  />
                )}
              </Fragment>
            </IconButton>

            {/* <Fragment>
                  Upload photo
                  {loading && (
                    <CircularProgress
                      size={30}
                      className={classes.progressSpinner}
                    />
                  )}
                </Fragment> */}
          </Tooltip>

          <TextField
            name="body"
            type="text"
            label="Scream!!"
            multiline
            rows="3"
            placeholder="Write something about the event"
            error={errors.body ? true : false}
            helperText={errors.body}
            className={classes.textField}
            onChange={this.handleChange}
            fullWidth
          />
          <Button
            type="submit"
            varient="contained"
            color="secondary"
            className={classes.submitButton}
            disabled={loading}
          >
            Submit
            {loading && (
              <CircularProgress size={30} className={classes.progressSpinner} />
            )}
          </Button>
        </form>
      </Fragment>
    );
  }
}

UploadScream.propTypes = {
  postScream: PropTypes.func.isRequired,
  UI: PropTypes.object.isRequired,
  postImage: PropTypes.func.isRequired,
  Image: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  UI: state.UI,
  Image: state.Image,
});

export default connect(mapStateToProps, { postScream, postImage })(
  withStyles(styles)(UploadScream)
);
